import { Button, cn } from '../ui';

/**
 * Liste "Hier liegen N" im Bereich "Auswahl": die Elemente unter der zuletzt angetippten Stelle (siehe `diagramStack.ts`), das markierte
 * ist hervorgehoben. Ein Klick markiert genau dieses Element - der Weg zu dem, was ein anderes verdeckt, auch ohne weiteres Tippen im Feld.
 */
export function OverlapList({
  names,
  indices,
  selected,
  disabled,
  onPick,
}: {
  /** Name je Zeile, in der Reihenfolge von `indices`. */
  names: readonly string[];
  indices: readonly number[];
  selected: number | null;
  disabled?: boolean;
  onPick: (index: number) => void;
}): JSX.Element {
  return (
    <div role="group" aria-label={`Hier liegen ${indices.length}`} data-testid="overlap-list" className="space-y-1.5 border-t border-slate-200 pt-2">
      <p aria-hidden="true" className="text-[0.68rem] font-semibold uppercase tracking-wide text-slate-500">
        Hier liegen {indices.length}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {indices.map((index, position) => (
          <Button
            key={index}
            type="button"
            size="sm"
            variant={selected === index ? 'primary' : 'secondary'}
            aria-pressed={selected === index}
            disabled={disabled}
            className={cn(selected === index && 'ring-2 ring-brand-500')}
            onClick={() => onPick(index)}
          >
            {names[position]}
          </Button>
        ))}
      </div>
      <p className="text-xs text-slate-500">Auch ein weiterer Tipp an dieselbe Stelle im Feld wählt das nächste Element.</p>
    </div>
  );
}
